<template>
  <div class="info-container">
    <el-row>
      <el-col :span="8">
        <el-row class="tcf-row">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                知识库分类
                <el-button icon="el-icon-plus" style="float: right;margin-top: -4px" @click="editType(null)" size="small" type="primary">添加分类</el-button>
              </div>
              <div class="card-content">
                <el-table
                  :data="typeData"
                  stripe
                  v-loading="typeLoading"
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    min-width="100"
                    label="分类名称"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="操作"
                    align="center"
                    width="180">
                    <template slot-scope="scope">
                      <el-button @click.stop="editType(scope.row)" size="mini" icon="el-icon-edit-outline" >编辑</el-button>
                      <el-button @click.stop="deleteType(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-row>
      </el-col>
      <el-col :span="16">
        <el-row class="tcf-row" style="padding-left: 0">
          <div class="card">
            <div class="card-body">
              <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="Search">搜索</el-button>
                </el-form-item>
                <el-form-item style="float: right">
                  <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加文章</el-button>
                </el-form-item>
              </el-form>
              <div class="card-content">
                <el-table
                  :data="tableData"
                  :row-style="{cursor: 'pointer'}"
                  stripe
                  v-loading="tableLoading"
                  style="width: 100%">
                  <el-table-column
                    label="封面图片"
                    align="center"
                    width="80">
                    <template slot-scope="scope">
                      <el-image
                        :src="scope.row.imgurl"
                        fit="cover"
                        style="width: 40px;height: 40px;"
                        :preview-src-list="[scope.row.imgurl]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    min-width="140"
                    label="标题"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span @click="openDetails(scope.row)" style="color:#409EFF;font-weight: bold">{{scope.row.title}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="typename"
                    label="分类"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="发布人"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                      <div v-if="scope.row.username!==''">{{scope.row.username}}</div>
                      <div v-if="scope.row.username===''">Elichain</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    align="center"
                    label="发布时间"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    label="浏览量"
                    align="center"
                    width="110">
                    <template slot-scope="scope">
                      {{scope.row.totalviews}}/{{scope.row.views}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="操作"
                    align="center"
                    fixed="right"
                    width="180">
                    <template slot-scope="scope">
                      <el-button @click.stop="editRow(scope.row)" size="mini" icon="el-icon-edit-outline" >编辑</el-button>
                      <el-button @click.stop="deleteRow(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="85%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="form" size="small" :model="infoData" label-width="80px" :rules="rules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="分类" prop="aktid">
          <el-select v-model="infoData.aktid" filterable placeholder="请选择">
            <el-option
              v-for="item in typeData"
              :label="item.name"
              :value="item.aktid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入标题" show-word-limit maxlength="100" v-model="infoData.title"/>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input placeholder="请输入描述" type="textarea" show-word-limit maxlength="300" v-model="infoData.remark"/>
        </el-form-item>
        <el-form-item label="封面">
          <SingleImg :key="imgkey" v-model="infoData.image" :oldurl="infoData.oldimgurl"/>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <tinymce ref="tinymce" v-model="infoData.content" :key="tinymcekey" :height="200" />
        </el-form-item>
        <el-form-item label="附件" prop="files">
          <MultiFile :key="imgkey" v-model="infoData.files"  :old="infoData.oldFiles"></MultiFile>
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" type="primary" @click="editNews('form')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAfterknowType, editAfterknowType, delAfterknowType, getAfterknowList, delAfterknow, editAfterknow } from '@/api/study/afterknow'
import SingleImg from '@/components/upload/SingleImg'
import tinymce from '@/components/Tinymce'
import MultiFile from '@/components/upload/MultiFile'

export default {
  computed: {
    user: getUser
  },
  components: {
    SingleImg,
    tinymce,
    MultiFile
  },
  data() {
    return {
      typeLoading: false,
      btnLoading: false,
      dialogVisible: false,
      typeData: [],
      tableData: [],
      searchForm: {
        search: ''
      },
      tableLoading: false,
      editTitle: '',
      imgkey: '',
      tinymcekey: '',
      infoData: {
        akid: null,
        aktid: null,
        image: null,
        oldimgurl: '',
        title: '',
        remark: '',
        content: '',
        files: [],
        oldFiles: []
      },
      rules: {
        aktid: [{ required: true, message: '请选择文章分类', trigger: 'change' }],
        title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入文章内容', trigger: 'blur' }]
      },
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getTypeData()
    this.getNewsData()
  },
  methods: {
    getTypeData() {
      this.typeLoading = true
      getAfterknowType().then(response => {
        this.typeData = response.data
        this.typeLoading = false
      }).catch(() => {
        this.typeLoading = false
      })
    },
    editType(row) {
      if (row !== null) {
        this.$prompt('请输入分类名称（20字以内）', '编辑分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputValue: row.name,
          inputErrorMessage: '分类名称不可为空'
        }).then(({ value }) => {
          editAfterknowType({ aktid: row.aktid, name: value }).then(response => {
            this.$message({
              type: 'success',
              message: '分类修改成功'
            })
            this.getTypeData()
          })
        }).catch(() => {})
      } else {
        this.$prompt('请输入分类名称（20字以内）', '添加分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '分类名称不可为空'
        }).then(({ value }) => {
          editAfterknowType({ aktid: 0, name: value }).then(response => {
            this.$message({
              type: 'success',
              message: '分类添加成功'
            })
            this.getTypeData()
          })
        }).catch(() => {})
      }
    },
    deleteType(row) {
      if (row != null) {
        this.$confirm('您确定要删除此分类吗?', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          delAfterknowType({ aktid: row.aktid }).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getTypeData()
          })
        }).catch(() => {
        })
      }
    },
    Search() {
      this.currentPage = 1
      this.getNewsData()
    },
    getNewsData() {
      this.tableLoading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search
      }
      getAfterknowList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getNewsData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNewsData()
    },
    deleteRow(row) {
      if (row != null) {
        this.$confirm('您确定要删除此文章吗?', '删除文章', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          delAfterknow({ akid: row.akid }).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getNewsData()
          })
        }).catch(() => {
        })
      }
    },
    editRow(row) {
      if (row != null) {
        this.editTitle = '编辑文章'
        this.infoData.akid = row.akid
        this.infoData.aktid = row.aktid
        this.infoData.image = { imgid: row.imgid, imgurl: row.imgurl }
        this.infoData.oldimgurl = row.imgurl
        this.infoData.content = row.content
        this.infoData.remark = row.remark
        this.infoData.title = row.title
        this.infoData.files = []
        this.infoData.oldFiles = []
        for (const item of row.filelst) {
          this.infoData.oldFiles.push({ id: item.fileid, name: item.filename })
        }
      } else {
        this.editTitle = '添加文章'
        this.infoData.akid = 0
        this.infoData.aktid = null
        this.infoData.image = null
        this.infoData.oldimgurl = ''
        this.infoData.content = ''
        this.infoData.remark = ''
        this.infoData.title = ''
        this.infoData.files = []
        this.infoData.oldFiles = []
      }
      this.tinymcekey = new Date().getTime()
      this.imgkey = new Date().getTime() + 2
      this.dialogVisible = true
      if (this.$refs['tinymce'] !== undefined) {
        this.$refs['tinymce'].setContent(this.infoData.content)
      }
    },
    editNews(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && !this.btnLoading) {
          this.btnLoading = true
          let imgid = ''
          if (this.infoData.image !== null) {
            imgid = this.infoData.image.imgid
          }
          const data = {
            akid: this.infoData.akid,
            aktid: this.infoData.aktid,
            imgid: imgid,
            title: this.infoData.title,
            remark: this.infoData.remark,
            content: this.infoData.content,
            userid: this.user.dUserid,
            fileids: this.infoData.files.join(',')
          }
          editAfterknow(data).then(response => {
            this.$message({
              type: 'success',
              message: response.msg
            })
            this.dialogVisible = false
            this.btnLoading = false
            this.getNewsData()
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    openDetails(row) {
      this.$router.push({ path: '/study/afterknow_detail/' + row.akid })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode{
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .search-area{
        float: right;
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
